import ImageWithPoints from '../../../Components/imageWithPoints/ImageWithPoints';
import docImg from '../../../assets/images/png/male-doc.png';
import checkIcon from '../../../assets/images/svg/check-white.svg';
import icon from '../../../assets/images/png/end-call-red.png';
import './benefitsOFMembership.css';

function BenefitsOFMembership() {
  return (
    <div className="benefitsOFMembership">
      <ImageWithPoints
        iconImage={icon}
        image={docImg}
        title="Benefits of Plus membership"
        icon={checkIcon}
        iconpoints={[
          {
            desc: 'Get all your health queries answered from any specialist online, any time of the day.'
          },
          {
            desc: 'Connect under 2 minutes on text, call or video - available 24 hrs a day, 7 days a week '
          },
          {
            desc: 'All online consultations are confidential. Only patient and the doctor can access the chats.'
          }
        ]}
      />
    </div>
  );
}

export default BenefitsOFMembership;
